import Vue from "vue"
import Vapi from "vuex-rest-api"

const events = new Vapi({
  axios: Vue.axios,
  queryParams: true,
  state: {
    event: null,
    events: [],
    allEvents: [],
  },
})

  // events
  .get({
    action: "listEvents",
    property: "events",
    path: ({ showId }) => `/events/?show=${showId}`,
  })
  .get({
    action: "listAllEvents",
    property: "allEvents",
    path: ({ showId }) => `/events/?show=${showId}&no_page=1`,
  })
  .post({
    action: "createEvent",
    path: "/events/",
  })
  .patch({
    action: "updateEvent",
    path: ({ id }) => `/events/${id}/`,
  })
  .delete({
    action: "destroyEvent",
    path: ({ id }) => `/events/${id}/`,
  })

  // finalize
  .getStore()

export default events
